const translations = {
    title: 'Subscription Summary'
};

export default translations;
